import React from 'react';
import WrapperInputGroup from "./WrapperInputGroup";
import PropTypes from "prop-types";

class SwitchCheckbox extends React.Component {
    constructor(props) {
        super(props);
        props.input.value = props.input.value || false;
    }

    render() {
        return [
            <input key="input-switch" type="checkbox" className="checkbox-switch" onFocus={this.props.onFocus} name={this.props.input.name}
                   id={this.props.input.id}
                   checked={this.props.input.value}
                   onChange={this.props.onChange} disabled={this.props.input.disabled}
                   required={this.props.input.required}
            />,
            <label key="label-switch" htmlFor={this.props.input.id} className="label-checkbox-switch">toogle-label</label>
        ]
    }
}

export const SwitchCheckboxGroup = WrapperInputGroup(SwitchCheckbox, {isCheckbox: true});


SwitchCheckboxGroup.propTypes = {
    input: PropTypes.shape({
        id: PropTypes.string.isRequired,
        value: PropTypes.bool,
        name: PropTypes.string,
        required: PropTypes.bool,
        disabled: PropTypes.bool,
    }).isRequired,
    onChange: PropTypes.func.isRequired
};


// WEBPACK FOOTER //
// ./src/input/base/SwitchCheckboxGroup.js